export default {
  learningResults: {},
  isForceResult: false,
  assignmentStats: {},
};
